import React from 'react'

import CourseRoutes from './routes'

function Course() {
  return <CourseRoutes />
}

export default Course